import { useState } from 'react';
import { Stack, Typography } from '@mui/material';
import GuestProfileRow from '../GuestProfileRow';
import GuestForm from '../../form/GuestForm';
import FullPageModal from '../../modal/FullPageModal';
import { CustomerGuest } from '../../../types/customers';
import { HAIRLINE } from './colors';

interface Props {
  customerId: string;
  businessId: string;
  guests: CustomerGuest[];
  onGuestChanged: () => unknown;
}

function CustomerGuestProfilesSection({
  customerId,
  businessId,
  guests,
  onGuestChanged,
}: Props) {
  const [editingGuest, setEditingGuest] = useState<CustomerGuest | null>(null);

  if (!guests.length) return null;

  return (
    <Stack sx={{ mt: '32px', pt: '24px', borderTop: `1px solid ${HAIRLINE}` }}>
      <Typography variant="h4" sx={{ color: 'text.primary' }}>
        Guest profiles
      </Typography>
      <Stack gap="10px" sx={{ mt: '14px' }}>
        {guests.map(guest => (
          <GuestProfileRow
            key={guest.id}
            guest={guest}
            onEdit={setEditingGuest}
          />
        ))}
      </Stack>
      {editingGuest && (
        <FullPageModal
          modalOpen
          setModalOpen={() => setEditingGuest(null)}
          name={`Edit Guest: ${editingGuest.firstName} ${editingGuest.lastName}`.trim()}>
          <GuestForm
            setModalOpen={() => setEditingGuest(null)}
            customerId={customerId}
            businessId={businessId}
            guest={editingGuest}
            onGuestSave={async () => {
              await onGuestChanged();
            }}
          />
        </FullPageModal>
      )}
    </Stack>
  );
}

export default CustomerGuestProfilesSection;
